import { FormField } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  formMode: FormMode;
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ formMode }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='grid grid-cols-2 justify-between gap-x-8 gap-y-4'>
        <div className='space-y-4'>
          <div>
            <div className='flex items-center'>
              <Label className='w-40 min-w-40'>Loại tăng giảm</Label>
              <FormField
                className='mr-2 w-20 min-w-[150px]'
                type='select'
                name='loai_tg_cc'
                options={[
                  { label: '1. Tăng công cụ', value: '1' },
                  { label: '2. Giảm công cụ', value: '2' }
                ]}
                disabled={formMode === 'view'}
              />
            </div>
          </div>

          <div className='flex items-center'>
            <Label className='w-40 min-w-40'>Mã tăng giảm</Label>
            <FormField className='mr-2 w-full' type='text' name='ma_tg_cc' disabled={formMode === 'view'} />
          </div>

          <div>
            <div className='flex items-center'>
              <Label className='w-40 min-w-40'>Tên tăng giảm</Label>
              <FormField className='mr-2 w-full' type='text' name='ten_tg_cc' disabled={formMode === 'view'} />
            </div>
          </div>

          <div>
            <div className='flex items-center'>
              <Label className='w-40 min-w-40'>Tên khác</Label>
              <FormField className='mr-2 w-full' type='text' name='ten_tg_cc2' disabled={formMode === 'view'} />
            </div>
          </div>

          <div>
            <div className='flex items-center'>
              <Label className='w-40 min-w-40'>Trạng thái</Label>
              <FormField
                className='mr-2 w-full'
                type='select'
                name='status'
                options={[
                  { label: '1. Còn sử dụng', value: '1' },
                  { label: '0. Không sử dụng', value: '0' }
                ]}
                disabled={formMode === 'view'}
              />
            </div>
          </div>

          {/* Hidden fields for required values */}
          <div className='hidden'>
            <FormField name='action' type='text' />
            <FormField name='param' type='text' />
          </div>
        </div>
      </div>
    </div>
  );
};
